import { Syringe } from "lucide-react";
import ResourcePage from "@/components/ResourcePage";
import { makeAdapter } from "@/lib/supabaseAdapter";
import ScanVaccinationCard from "@/components/ScanVaccinationCard";

const adapter = makeAdapter({ table: "vaccinations", filterColumn: "profile_id" });

export default function Vaccinations() {
  return (
    <ResourcePage
      config={{
        adapter,
        filterBy: "profile_id",
        extraAction: ({ profiles, refresh }) => (
          <ScanVaccinationCard profiles={profiles} onImported={refresh} />
        ),
        eyebrow: "Records",
        title: "Vaccinations",
        description: "Keep every immunization record at your fingertips.",
        icon: Syringe,
        accent: "bg-primary/10 text-primary",
        addLabel: "Add vaccination",
        testIdPrefix: "vacc",
        blank: () => ({
          profile_id: "",
          vaccine_name: "",
          date_administered: "",
          dose_number: "",
          provider: "",
          lot_number: "",
          date_due: "",
          status: "completed",
          notes: "",
        }),
        transform: (f, { profile }) => ({
          profile_id: f.profile_id,
          profile_name: profile?.name || null,
          vaccine_name: f.vaccine_name,
          date_administered: f.date_administered,
          dose_number: f.dose_number ? Number(f.dose_number) : null,
          provider: f.provider || null,
          lot_number: f.lot_number || null,
          date_due: f.date_due || null,
          status: f.status || "completed",
          notes: f.notes || null,
        }),
        fields: [
          { key: "vaccine_name", label: "Vaccine", required: true, span: 2, placeholder: "e.g. MMR" },
          { key: "date_administered", label: "Date given", type: "date", required: true },
          { key: "dose_number", label: "Dose #", type: "number", placeholder: "1" },
          { key: "provider", label: "Provider", placeholder: "Dr. Singh / Clinic" },
          { key: "lot_number", label: "Lot #", placeholder: "Optional" },
          { key: "date_due", label: "Next dose due", type: "date" },
          {
            key: "status",
            label: "Status",
            type: "select",
            options: [
              { value: "completed", label: "Completed" },
              { value: "scheduled", label: "Scheduled" },
              { value: "overdue", label: "Overdue" },
            ],
          },
          { key: "notes", label: "Notes", type: "textarea" },
        ],
        render: (v) => (
          <div>
            <div className="font-heading text-lg font-bold leading-tight">{v.vaccine_name}</div>
            <div className="mt-1 text-sm text-muted-foreground">
              Given {v.date_administered}
              {v.dose_number ? ` • dose ${v.dose_number}` : ""}
            </div>
            {v.provider && (
              <div className="mt-2 text-xs text-muted-foreground">By {v.provider}</div>
            )}
            {v.date_due && (
              <div className="mt-3 inline-block rounded-full bg-secondary/60 px-3 py-1 text-xs font-medium text-primary">
                Next due: {v.date_due}
              </div>
            )}
            {v.notes && (
              <div className="mt-3 text-xs text-muted-foreground">{v.notes}</div>
            )}
          </div>
        ),
      }}
    />
  );
}
